import { render, staticRenderFns } from "./imcNinos0a2A.vue?vue&type=template&id=5ea9c47c&scoped=true&"
import script from "./imcNinos0a2A.vue?vue&type=script&lang=js&"
export * from "./imcNinos0a2A.vue?vue&type=script&lang=js&"
import style0 from "./imcNinos0a2A.vue?vue&type=style&index=0&id=5ea9c47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9c47c",
  null
  
)

export default component.exports